import React from 'react'

const OrderDetails = () => {
  return (
    <div>
        
    </div>
  )
}

export default OrderDetails